<template>
    <div class="cashier">
        <mt-header title="收银台" fixed>
            <router-link to="/" slot="left">
                <mt-button icon="back"></mt-button>
            </router-link>
        </mt-header>
        <div class="content">
            <div class="order">
                <div class="ordernum">
                    <p>订单号</p>
                    <p>{{pagedata.order_sn}}</p>
                </div>
                <div class="orderamount">
                    <p>订单金额</p>
                    <p class="orange">￥{{pagedata.money}}元</p>
                </div>
            </div>
            <div class="chooses">
                <div class="choosetitle">支付方式</div>
                <van-radio-group v-model="radio">
                    <div>
                        <div v-show="!is_weixin" class="alipaypic"><p><img src="../../static/images/alipaypic.jpg" alt=""><span>支付宝支付</span></p><van-radio name="1" checked-color="#07c160"></van-radio></div>
                    </div>
                    <div class="wechatpic">
                        <p><img src="../../static/images/wechatpic.jpg" alt=""><span>微信支付</span></p><van-radio name="2" checked-color="#07c160"></van-radio>
                    </div>
                </van-radio-group>
            </div>
            <div class="button" @click="submitPay">
                <div class="btn"></div>
                <p>立即支付</p>
            </div>
        </div>
    </div>
</template>>

<script>
import { Toast, MessageBox } from 'mint-ui';
import { Checkbox, CheckboxGroup } from 'vant';
export default {
    data(){
        return{
            radio: '2',
            Message: '',
            pagedata:'',
            checkedValue:'2',
            is_weixin:false
        }
    },
    created(){
        this.order_id = this.$route.query.order_id || '';
        if (this.order_id) {
            this.getPage();
        } else {
            MessageBox.alert('参数错误，请返回重新下单', '提示').then(action => {
            this.$router.push('/ewmapply');
        });
        console.log(order_id)
      }
    },
    mounted(){
        //判断是否登陆
        if (!window.localStorage.getItem('is_check_login') || window.localStorage.getItem('is_check_login') == 0) {
           this.$router.push('/login');
        }
        // js判断是否是在微信浏览器中打开 false非,true在
        function is_weixn(){  
            var ua = navigator.userAgent.toLowerCase();  
            if(ua.match(/MicroMessenger/i)=="micromessenger") {  
                return true;  
            } else {  
                return false;  
            }  
        }
        this.is_weixin = is_weixn();
        console.log(is_weixn());
    },
    methods:{
        submitPay(){
            let data = {
                sign_id : this.order_id
            }
            let radio = this.radio
            if(radio == 1){
                window.location.href= 'https://yuan.znstny.cn/front/pay/alipay?sign_id=' + this.order_id
            }else{
                if( this.is_weixin == false){
                    window.location.href= 'https://yuan.znstny.cn/front/pay/weixinH5?sign_id=' + this.order_id
                }else{
                    window.location.href= 'https://shop.znstny.cn/front/pay/weixin?sign_id=' + this.order_id
                }
            }
        },
        getPage(){
            let data = {
                order_id : this.order_id
            };
            let url = '/front/signOrder/orderPayPage'
            this.$request.post(url,data,res => {
                console.log('res', res);
                if(res.status == 1){
                    if(res.result.status >= 0){//this.$router.push('/applyForRecord')
                        MessageBox.confirm('您已完成支付', '提示').then(action => { 
                            if (action == 'confirm') {
                                    this.$router.push('/applyForRecord')
                            }
                         }).catch(err => { 
                             if (err == 'cancel') {
                                this.$router.push('/')
                            } 
                         });
                    }else{
                        this.pagedata = res.result;
                    }
                }else if(res.status == 0){
                    MessageBox.confirm('该订单不存在', '提示')
                    this.$router.push('/projectList')
                }else{
                    Toast(res.msg)
                }
          })
        }
    }
}
</script>>

<style lang="scss" scoped>
.mint-header{
    color: #000000;
    background: #ffffff;
    height: 0.8rem;
}
.content{
    margin: 0 0.3rem;
    margin-top: 1rem;
    margin-bottom: 3px;
    .order{
        .ordernum{
            padding: 0.2rem;
            display: flex;
            background: #ffffff;
            justify-content: space-between;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }
        .orderamount{
            padding: 0.2rem;
            margin-top: 2px;
            display: flex;
            background: #ffffff;
            justify-content: space-between;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            .orange{
                color: #ff7e00;
            }
        }
    }
    .chooses{
        margin-top: 0.6rem;
        img{
            width: 0.5rem;
            height: 0.5rem;
            margin-right: 0.2rem;
            padding-bottom: 2px;
        }
        .alipaypic{
            display:flex;
            justify-content: space-between;
            padding: 0.2rem;
            margin-top: 2px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            background: #ffffff;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
        }
        .choosetitle{
            background: #ffffff;
            padding: 0.2rem;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }
        .wechatpic{
            display:flex;
            justify-content: space-between;
            padding: 0.2rem;
            margin-top: 2px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            background: #ffffff;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
        }
    }
    .button{
        height: 0.7rem;
        border-radius: 20px;
        margin-top: 1rem;
        color: #ffffff;
        background: #00b378;
        text-align: center;
        margin: 0.8rem 0.5rem 0 0.5rem;
        .btn{
            height: 0.14rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/cashier.vue